import { parseLinkOffKeys } from './linkSettings'

// De url van 'Vragenlijst delen': bouwer én lezer op één plek.
//
// Nodig omdat de pagina zijn url op positie leest en zeven afnemers hem met de
// hand bouwden, in drie vormen. Een verschoven segment geeft geen fout maar een
// lege pagina: zo stond 'Terug' op de QR-pagina zeven maanden stuk. Wie hierheen
// linkt, gebruikt buildShareQuestionnairePath; de pagina leest met
// readShareQuestionnairePath. shareQuestionnairePath.test.js toetst dat die twee
// elkaar teruglezen.
// AI-CONTEXT: See docs/pitfalls.md#routing-url-built-here-read-by-position-there
//
// Vorm: /:client/sharequestionnaire/:vragenlijst/:onderzoek[/:respondent][?meetmoment=…&uit=…]
// Het meetmoment staat in de query, niet in het pad: de pagina laat je het daar
// ook nog kiezen, en een extra segment zou de positie van alles erna verschuiven.

const SEGMENT = { questionnaire: 3, research: 4, respondent: 5 }

/**
 * @typedef {object} ShareQuestionnaireTarget
 * @property {string} questionnaireID - Questionnaires.ID
 * @property {string} researchID - Research.ID
 * @property {string} [respondentID] - Personas.ID, Adresses.ID of 'undefined' (anoniem); weglaten = niets gekozen
 * @property {string} [measureMomentID] - Al gekozen meetmoment
 * @property {string[]} [offKeys] - Instellingen die deze link uitzet (linkSettings)
 */

/**
 * @param {ShareQuestionnaireTarget & {client: string}} target
 * @returns {string}
 */
const buildShareQuestionnairePath = ({ client, questionnaireID, researchID, respondentID, measureMomentID, offKeys }) => {
    const respondent = respondentID ? `/${respondentID}` : ''
    const query = new URLSearchParams()
    if (measureMomentID) query.set('meetmoment', measureMomentID)
    const off = parseLinkOffKeys(`?uit=${(offKeys || []).join(',')}`)
    if (off.length) query.set('uit', off.join(','))
    const qs = query.toString().replace(/%2C/g, ',')
    return `/${client}/sharequestionnaire/${questionnaireID || ''}/${researchID || ''}${respondent}${qs ? `?${qs}` : ''}`
}

/**
 * @param {string[]} parts - `Location()`: het pad gesplitst op '/'
 * @param {string} search - `useLocation().search`
 * @returns {Required<ShareQuestionnaireTarget>}
 */
const readShareQuestionnairePath = (parts, search) => ({
    questionnaireID: parts[SEGMENT.questionnaire] || '',
    researchID: parts[SEGMENT.research] || '',
    respondentID: parts[SEGMENT.respondent] || '',
    measureMomentID: new URLSearchParams(search || '').get('meetmoment') || '',
    offKeys: parseLinkOffKeys(search),
})

export { buildShareQuestionnairePath, readShareQuestionnairePath }
